module.exports = __webpack_public_path__ + "media/bark03.71288256.mp3";